import { EdocumentType } from './edocument-type.model';
import { DocumentInclusion } from './document-inclusion.model';
import { PreferenceType } from './preference-type.model';
export class EdeliveryDocument {
    edocumentType: EdocumentType;
    docEligible: boolean;
    documentsIncluded: DocumentInclusion[];
    pin: string;
    preferenceType: PreferenceType;
    effectiveDate: Date;
    enrolled: boolean;
}
